<template>
	<div class="info-button">
		<slot/>
		<button @click.prevent="openInfoModal()">Info</button>
	</div>
</template>
<script>
export default {
	methods: {
		openInfoModal() {
			this.$vmodal.open({
				component: require("../modals/info/" + this.$attrs.modal).default,
			});
		}
	}
};
</script>
